import React from 'react';
import { Wrapper, LineChart, DonutChart, BarChart, MiniLineChart, CardDevices, CardList, DataTable, ProfileAccordion } from '../../components';

class Dashboard extends React.Component{
    
    constructor(props) {
        super(props);
    
        this.state = {
            dataDonut2: {
                "labels": ["Hip", "Hop", "Hat"],
                "datasets": [
                {
                    "borderWidth": 0,
                    "data": [
                    10,
                    20,
                    60
                  ]
                }
              ]
            },
            dataDonut3: {
                "labels": ["Run", "Pass", "Catch"],
                "datasets": [
                {
                    "backgroundColor": ["red","pink","lime"],
                    "borderWidth": 0,
                    "data": [
                    10,
                    70,
                    5
                  ]
                }
              ]
            },
            donutOptions: {
                cutoutPercentage: (this.props.cutoutPercentage||85),
                legend: {
                    position: "bottom",
                    labels: {
                      pointStyle: "circle",
                      usePointStyle: true
                    }
                }
            },
            dataLine1: {
                labels: ['Jan','Feb','Mar','Apr','May'],
                datasets: [
                  {
                    backgroundColor:'#ffffff',
                    borderColor:'#ffffff',
                    data: [10, 11, 4, 11, 4],
                    fill: false
                  }
                ]
            },
            dataLine2: {
                labels: ['Jan','Feb','Mar','Apr','May'],
                datasets: [
                  {
                    backgroundColor:'#ffffff',
                    borderColor:'#ffffff',
                    data: [5, 7, 8, 9, 11],
                    fill: false
                  }
                ]
            },
            dataLine3: {
                labels: ['Jan','Feb','Mar','Apr','May'],
                datasets: [
                  {
                    backgroundColor:'#ffffff',
                    borderColor:'#ffffff',
                    data: [11, 9, 8, 10, 4],
                    fill: false
                  }
                ]
            }
        };
    }
    
    render(){
        return (
            <Wrapper>
                <main className="flex-fill">
                    <div className="row mt-1">
                        <div className="col-xl-8 col-md-6 pb-3 wow fadeInUp" data-wow-delay=".3s">
                            <div className="card h-100 shadow-sm">
                                <div className="card-body p-xl-3 p-2 d-flex flex-column">
                                    <h4 className="font-weight-light mb-3">Visitors</h4>
                                    <div className="my-auto p-1 py-2">
                                        <LineChart />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 pb-3 wow fadeInUp" data-wow-delay=".4s">
                            <CardDevices />
                        </div>
                    </div>
                    <span className="anchor" id="snapshot"></span>
                    <div className="row mt-3 wow fadeInUp" data-wow-delay=".3s">
                        <div className="col-xl col-sm-6 pb-3">
                            <div className="card d-block p-1 h-100 shadow-sm">
                                <div className="row h-100 no-gutters">
                                    <div className="col-6 p-3 py-4">
                                        <h5 className="text-truncate">Health</h5>
                                        <h3 className="text-nowrap">99.3%</h3></div>
                                    <div className="col bg-light text-success d-flex">
                                        <h1 className="mb-0 mx-auto align-self-center"><a href="/" className="nav-link pb-0" title="View details"><span className="d-inline-block lnr lnr-heart"></span></a></h1></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl col-sm-6 pb-3">
                            <div className="card d-block p-1 h-100 shadow-sm">
                                <div className="row h-100 no-gutters">
                                    <div className="col-6 p-3 py-4">
                                        <h5 className="text-truncate">Cycles</h5>
                                        <h3>53</h3></div>
                                    <div className="col bg-light text-success d-flex">
                                        <h1 className="mb-0 mx-auto align-self-center"><a href="/" className="nav-link pb-0" title="View details"><span className="d-inline-block lnr lnr-history"></span></a></h1></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl col-sm-6 pb-3">
                            <div className="card d-block p-1 h-100 shadow-sm">
                                <div className="row h-100 no-gutters">
                                    <div className="col-6 p-3 py-4">
                                        <h5 className="text-truncate">Storage</h5>
                                        <h3 className="text-nowrap">69%</h3>
                                    </div>
                                    <div className="col bg-light text-success d-flex">
                                        <h1 className="mb-0 mx-auto align-self-center"><a href="/" className="nav-link pb-0" title="View details"><span className="d-inline-block lnr lnr-database"></span></a></h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl col-sm-6 pb-3">
                            <div className="card d-block p-1 h-100 shadow-sm">
                                <div className="row h-100 no-gutters">
                                    <div className="col-6 p-3 py-4">
                                        <h5 className="text-truncate">Signal</h5>
                                        <h3>4.1</h3></div>
                                    <div className="col bg-light text-success d-flex">
                                        <h1 className="mb-0 mx-auto align-self-center"><a href="/" className="nav-link pb-0" title="View details"><i className="lnr lnr-heart-pulse"></i></a></h1></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl py-3">
                            <div className="card h-100 shadow-sm wow fadeInUp" data-wow-delay=".5s">
                                <div className="card-body">
                                    <div className="h4 m-0">
                                        <i className="float-right lnr lnr-cloud-sync"></i>
                                        Latest Build v1.1.6
                                    </div>
                                    <div>75% complete</div>
                                    <div className="progress my-3">
                                        <div role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" className="progress-bar bg-primary w-75"></div>
                                    </div> <small className="text-muted"><a href="#modalSmall" data-toggle="modal">View build log</a></small></div>
                            </div>
                        </div>
                        <div className="col-xl py-3">
                            <div className="card h-100 shadow-sm wow slideInUp">
                                <div className="card-body">
                                    <div className="h4 m-0">
                                        <i className="float-right lnr lnr-database"></i>
                                        24 GB
                                    </div>
                                    <div>Backup in progress...</div>
                                    <div className="progress my-3">
                                        <div role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" className="progress-bar bg-dark w-25"></div>
                                    </div> <small className="text-muted">Contact the administrator for reports.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <span className="anchor" id="views"></span>
                    <div className="row py-3">
                        <div className="input-group col-lg-3 col-sm-6 pb-1">
                            <input className="form-control border-right-0 border" type="search" placeholder="Filter" />
                            <span className="input-group-append">
                                <button className="btn btn-outline-secondary border-left-0 border" type="button">
                                    <i className="lnr lnr-magnifier"></i>
                                </button>
                            </span>
                        </div>
                        <div className="col-lg-3 col-sm-6 pb-1">
                            <input type="text" className="form-control" placeholder="Station" />
                        </div>
                        <div className="col-lg-3 col-sm-6 pb-1">
                            <input type="text" className="form-control" placeholder="Location" />
                        </div>
                        <div className="col-lg-3 col-sm-6 pb-1">
                            <select className="form-control">
                                <option>Topics...</option>
                            </select>
                        </div>
                        <div className="col-md-3 col-xl-2">
                            <div className="sticky-top d-none d-md-block pt-3" id="sm">
                                <ul className="nav py-md-5 py-0 mt-3 flex-md-column flex-row justify-content-between border-right">
                                    <li className="nav-item"><a href="#sec1" className="nav-link active">Sources</a></li>
                                    <li className="nav-item"><a href="#sec2" className="nav-link">Sessions</a></li>
                                    <li className="nav-item">
                                        <a href="#sec3" className="nav-link">Demographics</a>
                                        <ul className="nav flex-md-column">
                                            <li className="nav-item"><a href="#sec3a" className="nav-link pl-4">Location<small><sup data-toggle="tooltip" data-placement="right" className="badge badge-danger badge-pill small font-weight-light align-middle mb-1" title="Active alerts">1</sup></small></a></li>
                                            <li className="nav-item"><a href="#sec3b" className="nav-link pl-4">Network</a></li>
                                        </ul>
                                    </li>
                                    <li className="nav-item"><a href="#sec4" className="nav-link">Technology</a></li>
                                    <li className="nav-item"><a href="#sec5" className="nav-link">Behavior</a></li>
                                    <li className="nav-item"><a href="#sec6" className="nav-link">Reviews</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col px-2">
                            <div className="position-relative py-4">
                                <div className="anchor py-md-3 py-2" id="sec1"></div>
                                <h6 className="my-4 pt-2 text-muted text-uppercase">Sources</h6>
                                <section className="row text-center no-gutters py-3 wow slideInUp">
                                    <div className="col-xl-4 col-sm-6">
                                        <DonutChart ref="donutChart1" options={this.state.donutOptions} className="mt-3 mx-auto" />
                                    </div>
                                    <div className="col-xl-4 col-sm-6">
                                        <DonutChart ref="donutChart2" options={this.state.donutOptions} data={this.state.dataDonut2} className="mt-3 mx-auto" />
                                    </div>
                                    <div className="col-xl-4 col-sm-6 mx-auto">
                                        <DonutChart ref="donutChart3" options={this.state.donutOptions} data={this.state.dataDonut3} className="mt-3 mx-auto" />
                                    </div>
                                </section>
                                <hr className="border-light" />
                                <div className="anchor py-md-3 py-2" id="sec2"></div>
                                <h6 className="my-4 text-muted text-uppercase">Sessions</h6>
                                <section className="row py-3 wow slideInUp">
                                    <div className="col-xl-4 col-sm-6 pb-4">
                                        <div className="card bg-primary border-0 mb-1 h-100 shadow-sm">
                                            <div className="card-body d-block text-white">
                                                <h6 className="text-uppercase float-right mt-1"><i className="lnr lnr-rocket"></i> Activity</h6>
                                                <h1 className="display-4 m-0">96%</h1>
                                                <div>
                                                    <MiniLineChart ref="lineChart1" data={this.state.dataLine1} className="mb-2 p-1 mx-auto" height="130" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-sm-6 pb-4">
                                        <div className="card border-0 mb-1 h-100 shadow-sm">
                                            <div className="card-body d-block text-primary">
                                                <h6 className="text-uppercase float-right mt-1"><i className="lnr lnr-leaf"></i> Nodes</h6>
                                                <h1 className="display-4 m-0">32</h1>
                                                <div>
                                                    <MiniLineChart ref="lineChart2" data={this.state.dataLine2} className="mb-2 p-1 mx-auto" height="130" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-sm-8 mx-auto pb-4">
                                        <div className="card text-white bg-success border-0 mb-1 h-100 shadow-sm">
                                            <div className="card-body d-block text-white">
                                                <h6 className="text-uppercase float-right mt-1"><i className="lnr lnr-users"></i> Users</h6>
                                                <h1 className="display-4 m-0">64</h1>
                                                <div>
                                                    <MiniLineChart ref="lineChart3" data={this.state.dataLine3} className="mb-2 p-1 mx-auto" height="130" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                <hr className="border-light" />
                                <div className="anchor py-md-3 py-2" id="sec3"></div>
                                <h6 className="my-4 text-muted text-uppercase">Demographics</h6>
                                <section className="row py-3">
                                    <div className="col">
                                        <div className="alert alert-secondary alert-dismissable rounded-0 p-2">
                                            <button className="btn btn-link close font-weight-light" data-dismiss="alert">
                                                <span className="align-text-top small">×</span>
                                            </button>
                                            Notice: Data results are cached for 30 minutes.
                                        </div>
                                        <div className="pb-3">
                                    <div className="anchor pb-5" id="sec3a"></div>
                                    <h6 className="py-2">Location</h6>
                                    <div className="table-responsive">
                                        <table className="table table-hover table-sm mt-2">
                                        <tbody>
                                            <tr>
                                                <th className="w-25">IP</th>
                                                <th className="w-25">Location</th>
                                                <th className="w-25">Date</th>
                                                <th className="w-25">Visits</th>
                                            </tr>
                                            <tr>
                                                <td>12.34.22.102</td>
                                                <td>Westfield</td>
                                                <td>08.05.18</td>
                                                <td>2323</td>
                                            </tr>
                                            <tr>
                                                <td>12.44.22.110</td>
                                                <td>Galway</td>
                                                <td>08.05.18</td>
                                                <td>5362</td>
                                            </tr>
                                            <tr>
                                                <td>12.34.22.102</td>
                                                <td>Bern</td>
                                                <td>08.05.18</td>
                                                <td><a href="." className="mx-1 float-right"><i className="icon-exclamation icons text-danger"></i></a> 153</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                    <div className="anchor pb-5" id="sec3b"></div>
                                    <h6 className="py-2">Network</h6>
                                    <div className="table-responsive">
                                        <table className="table table-hover table-sm mt-2">
                                        <tbody>
                                            <tr>
                                                <th className="w-25">IP</th>
                                                <th className="w-25">Hostname</th>
                                                <th className="w-25">Source</th>
                                                <th className="w-25">Visits</th>
                                            </tr>
                                            <tr>
                                                <td>12.34.22.102</td>
                                                <td>getbootstrap.com</td>
                                                <td>referral</td>
                                                <td>3892</td>
                                            </tr>
                                            <tr>
                                                <td>12.34.22.102</td>
                                                <td>blog.getbootstrap.com</td>
                                                <td>direct</td>
                                                <td>1533</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                </div>
                                    </div>
                                </section>
                                <hr className="border-light" />
                                <div className="anchor py-md-3 py-2" id="sec4"></div>
                                <h6 className="my-4 text-muted text-uppercase">Technology</h6>
                                <section className="row text-center py-3">
                                    <div className="col-6 col-lg-3 pb-2"><img src="//gradientjoy.com/150x150?id=117" alt="thumbnail" className="mx-auto img-fluid rounded-circle" />
                                        <h5 className="text-truncate mt-2">Responsive</h5>
                                        <div className="text-truncate text-muted">Device agnostic</div>
                                    </div>
                                    <div className="col-6 col-lg-3 pb-2"><img src="//gradientjoy.com/150x150?id=117" alt="thumbnail" className="mx-auto img-fluid rounded-circle" />
                                        <h5 className="text-truncate mt-2">HTML5</h5>
                                        <div className="text-truncate text-muted">Standards-based</div>
                                    </div>
                                    <div className="col-6 col-lg-3 pb-2"><img src="//gradientjoy.com/150x150?id=117" alt="thumbnail" className="mx-auto img-fluid rounded-circle" />
                                        <h5 className="text-truncate mt-2">Progressive</h5>
                                        <div className="text-truncate text-muted">Framework</div>
                                    </div>
                                    <div className="col-6 col-lg-3 pb-2"><img src="//gradientjoy.com/150x150?id=117" alt="thumbnail" className="mx-auto img-fluid rounded-circle" />
                                        <h5 className="text-truncate mt-2">Bootstrap 4</h5>
                                        <div className="text-truncate text-muted">Mobile-first</div>
                                    </div>
                                </section>
                                <hr className="border-light" />
                                <div className="anchor py-md-3 py-2" id="sec5"></div>
                                <h6 className="my-4 text-muted text-uppercase">Behavior</h6>
                                <section className="row py-3">
                                    <div className="col">
                                        <div className="alert alert-primary alert-dismissable rounded-0 p-2">
                                        <button className="btn btn-link close font-weight-light" data-dismiss="alert">
                                            <span className="align-text-top small">×</span>
                                        </button>
                                        Displaying results for the last 7 months
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table table-hover table-bordered my-3">
                                            <thead>
                                                <tr className="text-center">
                                                    <th className="text-left">Metric</th>
                                                    <th>J</th>
                                                    <th>F</th>
                                                    <th>M</th>
                                                    <th>A</th>
                                                    <th>M</th>
                                                    <th>J</th>
                                                    <th>J</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="text-center">
                                                    <td className="text-left text-nowrap"><span className="badge badge-pill bg-success">&nbsp;</span> Visits</td>
                                                    <td>12</td>
                                                    <td>20</td>
                                                    <td>12</td>
                                                    <td>18</td>
                                                    <td>10</td>
                                                    <td>6</td>
                                                    <td>19</td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td className="text-left text-nowrap"><span className="badge badge-pill bg-primary">&nbsp;</span> Hours</td>
                                                    <td>16</td>
                                                    <td>23</td>
                                                    <td>8</td>
                                                    <td>15</td>
                                                    <td>11</td>
                                                    <td>8</td>
                                                    <td>15</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        </div>
                                    </div>
                                </section>
                                <hr className="border-light" />
                                <div className="anchor py-md-3 py-2" id="sec6"></div>
                                <h6 className="my-4 text-muted text-uppercase">Reviews</h6>
                                <section className="row py-3">
                                    <div className="col">
                                        <div className="card shadow-sm">
                                            <div className="row">
                                                <div className="col-xl-4">
                                                    <div className="card-body h-100 d-flex flex-column">
                                                        <span className="display-4">1,219</span>
                                                        <h6 className="font-weight-light mb-3">There are 4 new reviews</h6>
                                                        <div className="mt-auto p-1">
                                                            <BarChart className="w-100" id="chBar" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col col-xl-auto p-0 mx-3 mx-xl-0 border-bottom border-right border-light"></div>
                                                <div className="col-xl">
                                                    <ul className="list-unstyled pr-3">
                                                        <li className="p-3">
                                                            <div className="d-flex p-2">
                                                                <span className="text-secondary display-4 mr-3"><i className="lnr lnr-smile"></i></span>
                                                                <div className="ml-2">
                                                                    <h3 className="card-title font-weight-light">Positive</h3>
                                                                    <h6 className="font-weight-light">197 Reviews</h6>
                                                                </div>
                                                            </div>
                                                            <div className="progress" style={{height:"5px"}}>
                                                                <div className="progress-bar bg-success w-75" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                                            </div>
                                                        </li>
                                                        <li className="p-3">
                                                            <div className="d-flex p-2">
                                                                <span className="text-muted display-4 mr-3"><i className="lnr lnr-sad"></i></span>
                                                                <div className="ml-2">
                                                                    <h3 className="card-title font-weight-light">Negative</h3>
                                                                    <h6 className="font-weight-light">14 Reviews</h6>
                                                                </div>
                                                            </div>
                                                            <div className="progress" style={{height:"5px"}}>
                                                                <div className="progress-bar progress-bar-striped progress-bar-animated bg-danger w-25"  role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                            </div>
                                                        </li>
                                                        <li className="p-3">
                                                            <div className="d-flex p-2">
                                                                <span className="text-secondary display-4 mr-3"><i className="lnr lnr-neutral"></i></span>
                                                                <div className="ml-2">
                                                                    <h3 className="card-title font-weight-light">Neutral</h3>
                                                                    <h6 className="font-weight-light">89 Reviews</h6>
                                                                </div>
                                                            </div>
                                                            <div className="progress" style={{height:"5px"}}>
                                                                <div className="progress-bar bg-primary w-50" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div className="w-100 py-4">
                        </div>
                    </div>
                    <div className="anchor" id="areas"></div>
                    <div className="row py-3">
                        <div className="col-12 wow fadeInUp">
                            <div className="position-relative">
                                <ul className="nav nav-tabs" role="tablist">
                                    <li className="nav-item"><a href="#tab1" className="nav-link text-uppercase active" data-toggle="tab" data-target="#tab1" role="tab">Reports</a></li>
                                    <li className="nav-item ml-auto"><a href="#tab2" className="nav-link text-uppercase" data-toggle="tab" data-target="#tab2" role="tab">Log</a></li>
                                    <li className="nav-item"><a href="#tab3" className="nav-link text-uppercase" data-toggle="tab" data-target="#tab3" role="tab">Bots</a></li>
                                </ul>
                                <div className="tab-content shadow-sm border border-top-0 rounded-bottom p-3">
                                    <div className="tab-pane active" id="tab1" role="tabpanel">
                                        <DataTable />
                                    </div>
                                    <div className="tab-pane" id="tab2" role="tabpanel">
                                        <CardList />
                                    </div>
                                    <div className="tab-pane" id="tab3" role="tabpanel">
                                        <div className="row">
                                            <div className="col-xl-3 col-lg-12 col-md-3 d-flex flex-column">
                                                <div className="card text-white bg-primary flex-grow-1 shadow-sm">
                                                    <div className="card-body">
                                                        <h3 className="card-title">Bots</h3>
                                                        <p className="card-text">Click on a robot friend to learn more about them.</p>
                                                        <button className="btn btn-outline-light border-white text-white">Button</button>
                                                    </div>
                                                </div>
                                                <div className="card text-white bg-primary my-4 flex-grow-1 shadow-sm">
                                                    <div className="card-body">
                                                        <div className="float-right dropdown show"><button data-toggle="dropdown" className="btn btn-link p-0 dropdown-toggle text-white"><i className="align-middle lnr lnr-cog"></i></button>
                                                            <div className="dropdown-menu dropdown-menu-right">
                                                                <button className="dropdown-item">Action</button>
                                                                <button className="dropdown-item">Another action</button>
                                                            </div>
                                                        </div>
                                                        <h4 className="card-title">Working</h4>
                                                        <p className="card-text">
                                                            This template features <em>working</em> components to demonstrate realistic use and implementation.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="card text-white bg-primary flex-grow-1 shadow-sm">
                                                    <div className="card-body">
                                                        <h3 className="card-title">Flexible</h3>
                                                        <p className="card-text">The beauty of responsive design is that it works on all devices.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <ProfileAccordion className="border rounded shadow-sm" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </Wrapper>
        );
    }
}

export default Dashboard;
